import axios from 'axios';
import { user_api_root } from './setup';

function resource() {
  return `${user_api_root}/orgs`;
}

export function create(orgName, addons = []) {
  return axios.post(`${resource()}/create`, { orgName, addons });
};

export function get(orgId) {
  return axios.get(`${resource()}/${orgId}`);
}

export function users(orgId) {
  return axios.get(`${resource()}/${orgId}/users`);
}

export function createOrgUser(orgId, data) {
  return axios.post(`${resource()}/${orgId}/users/create`, data);
}

export function invite(orgId, data) {
  return axios.post(`${resource()}/${orgId}/users/invite`, data);
}

export function createChildTenant(orgId, tenantName) {
  return axios.post(`${resource()}/${orgId}/child-tenants/create`, { childTenantName: tenantName });
} 

export function deleteChildTenant(orgId, tenantId) {
  return axios.delete(`${resource()}/${orgId}/child-tenants/${tenantId}`);
}

export function createTenantUser(orgId, data) {
  return axios.post(`${resource()}/${orgId}/users/tenant-add-users`, data);
}

export function deleteTenantUser(orgId, data) {
  return axios.post(`${resource()}/${orgId}/users/tenant-remove-users`, data);
}

export function tenants(orgId) {
  return axios.get(`${resource()}/${orgId}/child-tenants`);
}

export function user(orgId, userId) {
  return axios.get(`${resource()}/${orgId}/users/${userId}`);
}

export function update(orgId, userId, data) {
  return axios.put(`${resource()}/${orgId}/users/${userId}`, data);
}

export function deleteUser(orgId, userId) {
  return axios.delete(`${resource()}/${orgId}/users/${userId}`);
}

export function orgs(userId) {
  return axios.get(`${resource()}/org-summary/${userId}`);
}

export function getPublishableKey(orgId) {
  return axios.get(`${resource()}/${orgId}/billing/stripe-key`);
}

export function createSubscription(orgId, data) {
  return axios.post(`${resource()}/${orgId}/billing/create-subscription`, data);
}

export function getPermissions(orgId) {
  return axios.get(`${resource()}/${orgId}/users/get-permissions`);
}

export function customerPortal(orgId) {
  return axios.get(`${resource()}/${orgId}/billing/customer-portal`);
}

export function enterpriseRequest(orgId) {
  return axios.post(`${resource()}/${orgId}/billing/enterprise-enquiry`);
}

export function cancelSubscription(orgId, data) {
  return axios.post(`${resource()}/${orgId}/billing/cancel-subscription`, data);
}

export function notifyMe(orgId, userId, data) {
  return axios.post(`${resource()}/${orgId}/users/${userId}/notifications/subscriptions`, data);
}

export function generateAPIKey(orgId, userId) {
  return axios.post(`${resource()}/${orgId}/users/${userId}/generate-api-key`);
}

export function revokeAPIKey(orgId, userId, apiKey) {
  return axios.delete(`${resource()}/${orgId}/users/${userId}/revoke-api-key`, { data: { apiKey } });
}